import React from 'react';

const SVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32">
    <path d="M32 31.955H0V0h12.409v4H4v23.955h24v-8.76h4z" />
    <path d="M32 13.259V0H18.837l-.024 3.656 6.916-.014-11.197 11.306 2.66 2.675 11.19-11.3.024 6.927 3.594.009z" />
  </svg>
);
export default SVG;
